import { useHead } from '@vueuse/head'

import { i18n } from './localization'

export default (head) =>
  useHead({
    ...head,
    title: head.title
      ? `${head.title} | ${import.meta.env.VITE_VUE_APP_SITE_NAME}`
      : import.meta.env.VITE_VUE_APP_SITE_NAME,
    htmlAttrs: { lang: i18n.global.locale, amp: false },
  })
